module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Items")]), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('v-list-tile', {
      key: index
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "black"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(item['.key'])
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-container', [_c('v-text-field', {
    attrs: {
      "label": "Item Name"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addItem()
      }
    },
    model: {
      value: (_vm.Item.name),
      callback: function($$v) {
        _vm.$set(_vm.Item, "name", $$v)
      },
      expression: "Item.name"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("Add Item")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5ad63f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 471
// module chunks = 1